import { render } from "./ArticlesOverTime.vue?vue&type=template&id=95307b06"
import script from "./ArticlesOverTime.vue?vue&type=script&lang=js"
export * from "./ArticlesOverTime.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__